// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__37iDJ","title":"InfoRow_title__3zzQE"};